// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"c0dcd828","453":"95c8d6d3"}[chunkId] + ".chunk.js";
};